import { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
//icons
import { IoBagCheckOutline, IoSave } from "react-icons/io5";

const CheckoutCartSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);

  // console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [modalVisible, setModalVisible] = useState(false);

  const {
    register,
    setValue,
    watch,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      checkoutCart: {
        couponSystem: {
          enabled: true,
          activeCoupons: [],
        },
      },
    },
  });
  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "checkoutCart.couponSystem.activeCoupons",
  });

  const couponEnabled = watch("checkoutCart.couponSystem.enabled");

  return (
    <div>
      {/* Checkout & Cart Settings Section */}
      <form
        style={{ marginTop: "80px" }}
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "Checkout & Cart settings updated successfully!")
        )}
      >
        <div className="mb-4">
          <h5 className="d-flex align-content-center gap-2">
            <IoBagCheckOutline />  Checkout & Cart Settings
          </h5>
          <hr />

          <div className="row ">
            {/* Enable Coupon System */}
            <div className="row mb-2 mt-2 col-sm-6">
              <label className="col-sm-6">Enable Coupon System</label>
              <div className="col-sm-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="couponSystem"
                    checked={couponEnabled}
                    onChange={(e) =>
                      setValue(
                        "checkoutCart.couponSystem.enabled",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="couponSystem">
                    {couponEnabled ? "Enabled" : "Disabled"}
                  </label>
                </div>
              </div>
            </div>

            {/* Guest Checkout */}
            <div className="row mb-2 mt-2 col-sm-6">
              <label className="col-sm-6">Enable Guest Checkout</label>
              <div className="col-sm-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="guestCheckout"
                    {...register("checkoutCart.guestCheckout")}
                  />
                  <label className="form-check-label" htmlFor="guestCheckout">
                    Enable
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Active Coupons List - Show if Coupon System is Enabled */}
          {watch("checkoutCart.couponSystem.enabled") && (
            <div className="mb-3">
              <label className="form-label">Active Coupons</label>
              {fields.length === 0 && (
                <div className="card p-3 mb-3">
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Coupon Code"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.code"
                        )}
                      />
                    </div>
                    <div className="col-md-6">
                      <select
                        className="form-select"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.discountType"
                        )}
                      >
                        <option value="percentage">Percentage</option>
                        <option value="flat">Flat</option>
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.amount"
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Min Purchase"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.minPurchase"
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Max Discount"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.maxDiscount"
                        )}
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="date"
                        className="form-control"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.validFrom"
                        )}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="date"
                        className="form-control"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.validTill"
                        )}
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Usage Limit"
                        {...register(
                          "checkoutCart.couponSystem.activeCoupons.0.usageLimit"
                        )}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="isActive0"
                          {...register(
                            "checkoutCart.couponSystem.activeCoupons.0.isActive"
                          )}
                        />
                        <label className="form-check-label" htmlFor="isActive0">
                          Active
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {fields.map((item, index) => (
                <div className="card p-3 mb-3" key={item.id}>
                  {/* Coupon Fields */}
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Coupon Code"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.code`
                        )}
                      />
                    </div>
                    <div className="col-md-6">
                      <select
                        className="form-select"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.discountType`
                        )}
                      >
                        <option value="percentage">Percentage</option>
                        <option value="flat">Flat</option>
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.amount`
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Min Purchase"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.minPurchase`
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Max Discount"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.maxDiscount`
                        )}
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="date"
                        className="form-control"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.validFrom`
                        )}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="date"
                        className="form-control"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.validTill`
                        )}
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Usage Limit"
                        {...register(
                          `checkoutCart.couponSystem.activeCoupons.${index}.usageLimit`
                        )}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`isActive${index}`}
                          {...register(
                            `checkoutCart.couponSystem.activeCoupons.${index}.isActive`
                          )}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`isActive${index}`}
                        >
                          Active
                        </label>
                      </div>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm ms-3"
                        onClick={() => remove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              <button
                type="button"
                className="btn btn-dark me-1"
                onClick={() =>
                  append({
                    code: "",
                    discountType: "percentage",
                    amount: 0,
                    minPurchase: 0,
                    maxDiscount: undefined,
                    validFrom: "",
                    validTill: "",
                    isActive: true,
                    usageLimit: undefined,
                  })
                }
              >
                Add Coupon
              </button>
            </div>
          )}

          {/* Submit */}
          <div className="d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1" />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default CheckoutCartSettings;
